import Cookies from 'js-cookie';
import { siteTokenKey } from '@/settings';

const PRESERVED_COOKIE_KEYS = new Set([
  'agent_new_dev_token',
  'agent_new_dev_tokenInfo',
]);

// 判断是域名还是IP地址
function isIp() {
  let url = document.domain;
  var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; //正则表达式
  if (re.test(url)) {
    if (
      RegExp.$1 < 256 &&
      RegExp.$2 < 256 &&
      RegExp.$3 < 256 &&
      RegExp.$4 < 256
    )
      return true;
  }
  return false;
}

function domain() {
  return isIp()
    ? document.domain
    : document.domain.split(".").slice(-2).join(".");
}

/** 
 * 获取本地Token
 */
export function getToken(key) {
  return Cookies.get(key || siteTokenKey);
}

/** 
 * 设置存储Token
 */
export function setToken(key, val) {
  return Cookies.set(key, val, { domain: domain() });
}

// 设置cookie内容
export function setCookieVal(key, val, time) {
  return addCookieAndDomain(key, val, time || 0, domain());
}

function addCookieAndDomain(key, value, objHours, strdomain) {
  let str = key + '=' + value + ';domain=' + strdomain;
  if (objHours > 0) {
    let date = new Date();
    let ms = objHours * 3600 * 1000;
    date.setTime(date.getTime() + ms);
    str += ';expires=' + date.toGMTString() + ';path=/';
  } else {
    str += ';path=/';
  }
  document.cookie = str;
}

/** 
 * 移除本地Token
 */
export function removeToken() {
  clearCookie();
  return Cookies.remove(siteTokenKey);
}

// 删除指定的cookie
export function removeCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  var cookieStr = "";
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      document.cookie = c + ';expires=' + new Date(0).toUTCString();
    } else {
      cookieStr += c;
      cookieStr += ";";
    }
    document.cookie = cookieStr;
  }
}

function clearCookie() {
  // eslint-disable-next-line no-useless-escape
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g); // eslint-disable-line
  if (keys) {
    for (var i = keys.length; i--;) {
      if (PRESERVED_COOKIE_KEYS.has(keys[i])) {
        continue;
      }
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() + ';domain=' + domain();
    }
  }
}


